/** Fluides frigorigènes et CERFA : module froid et droit de saisie (§16.2). */
import { lazy } from 'react';
import type { AppRoute, RouteGate } from '../../app/route-types.js';
import { NEW_FLUID_PATH } from './fluids-model.js';

const FluidsPage = lazy(() => import('./FluidsPage.js').then((m) => ({ default: m.FluidsPage })));
const CylinderNewPage = lazy(() => import('./CylinderNewPage.js').then((m) => ({ default: m.CylinderNewPage })));
const FluidTypeNewPage = lazy(() => import('./FluidTypeNewPage.js').then((m) => ({ default: m.FluidTypeNewPage })));
const FluidTypeCorrectionPage = lazy(() =>
  import('./FluidTypeCorrectionPage.js').then((m) => ({ default: m.FluidTypeCorrectionPage })));
const LeakCheckNewPage = lazy(() => import('./LeakCheckNewPage.js').then((m) => ({ default: m.LeakCheckNewPage })));
const OperationNewPage = lazy(() => import('./OperationNewPage.js').then((m) => ({ default: m.OperationNewPage })));
const CorrectionPage = lazy(() => import('./CorrectionPage.js').then((m) => ({ default: m.CorrectionPage })));
const CerfaPage = lazy(() => import('./CerfaPage.js').then((m) => ({ default: m.CerfaPage })));
const DetectorPage = lazy(() => import('./DetectorPage.js').then((m) => ({ default: m.DetectorPage })));
const CerfaValidationPage = lazy(() => import('./CerfaValidationPage.js').then((m) => ({ default: m.CerfaValidationPage })));

const fluids: RouteGate = { anyOf: ['fluids.record'], module: 'refrigerants' };
/** Détecteurs de fuite : réglages de l'entreprise, en plus du module froid. */
const detectors: RouteGate = { ...fluids, allOf: ['settings.manage'] };
/** Corriger le registre : le droit de l'exporter et de le corriger, en plus de la saisie. */
const registryCorrection: RouteGate = { ...fluids, allOf: ['compliance.validate'] };

export const fluidsRoutes: AppRoute[] = [
  { path: '/fluides', element: <FluidsPage />, gate: fluids },
  { path: '/fluides/bouteilles/nouvelle', element: <CylinderNewPage />, gate: fluids },
  { path: NEW_FLUID_PATH, element: <FluidTypeNewPage />, gate: fluids },
  { path: '/fluides/types/:id/correction', element: <FluidTypeCorrectionPage />, gate: fluids },
  { path: '/fluides/controles/nouveau', element: <LeakCheckNewPage />, gate: fluids },
  { path: '/fluides/operations/nouvelle', element: <OperationNewPage />, gate: fluids },
  { path: '/fluides/registre/:id/correction', element: <CorrectionPage />, gate: registryCorrection },
  { path: '/fluides/detecteurs/nouveau', element: <DetectorPage />, gate: detectors },
  { path: '/fluides/detecteurs/:id', element: <DetectorPage />, gate: detectors },
  { path: '/fluides/cerfa/nouvelle', element: <CerfaPage />, gate: fluids },
  { path: '/fluides/cerfa/:id', element: <CerfaPage />, gate: fluids },
  { path: '/fluides/cerfa/:id/validation', element: <CerfaValidationPage />, gate: fluids },
];
